import React, { useState, useEffect } from "react";
import { PayPalButtons } from "@paypal/react-paypal-js";
import { Fragment } from "react";
import getPaypalMarket from "module/functions/getPaypalMarket";

const PayPalComponent = (props) => {
  const { amount, transactionComplete, formValues } = props;
  const [windowSize, setWindowSize] = useState(getWindowSize());
  const [width, setWidth] = useState("");

  function getWindowSize() {
    const { innerWidth } = window;
    return { innerWidth };
  }

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }
    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  useEffect(() => {
    if (windowSize.innerWidth < 1024) {
      setWidth("100%");
    } else {
      setWidth("80%");
    }
  }, [windowSize]);

  return (
    <Fragment>
      <div className="form__form-wrapper">
        <div style={{ position: "relative", width: width }}>
          <PayPalButtons
            style={{ layout: "vertical" }}
            fundingSource="paypal"
            createOrder={(data, actions) => {
              return actions.order
                .create({
                  purchase_units: [
                    {
                      custom_id: getPaypalMarket(),
                      amount: {
                        value: amount,
                      },
                    },
                  ],
                  application_context: {
                    shipping_preference: "NO_SHIPPING",
                  },
                })
                .then((d) => {
                  return d;
                });
            }}
            onApprove={(data, actions) => {
              return actions.order.capture().then((details) => {
                transactionComplete(details, formValues["name.value"]);
              });
            }}
          />

          <PayPalButtons
            style={{ layout: "vertical" }}
            fundingSource="card"
            createOrder={(data, actions) => {
              return actions.order
                .create({
                  purchase_units: [
                    {
                      custom_id: getPaypalMarket(),
                      amount: {
                        value: amount,
                      },
                    },
                  ],
                  application_context: {
                    shipping_preference: "NO_SHIPPING",
                  },
                })
                .then((d) => {
                  return d;
                });
            }}
            onApprove={(data, actions) => {
              return actions.order.capture().then((details) => {
                transactionComplete(details, formValues["name.value"]);
              });
            }}
          />
        </div>
      </div>
    </Fragment>
  );
};

export default PayPalComponent;
